import { MnemonicRequest, MnemonicResponse } from '../dto/mnemonics';
import { httpArg, httpGet, httpRoute } from '../infrastructure/http/http-decorators';

@httpRoute('/api/mnemonics')
export abstract class IMnemonicService {
	@httpGet('get')
	getMnemonics(@httpArg('request') request: MnemonicRequest): Promise<MnemonicResponse> {
		void request;
		throw new Error('Not implemented');
	}
}
